/**
 * Function to set up BackboneJS objects needed for
 *	- Activity Module on Summary page
 *	- Activity Full-page load
 */
import TransactionCollectionView from 'view/activity/transactionCollectionView';
import TransactionCollection from 'collection/activity/transactionCollection';
import ActivityModel from 'model/activity/activityModel';
import MessageModel from 'model/activity/messageModel';
import MessageView from 'view/activity/messageView';
import FilterModel from 'model/activity/filterModel';
import FilterView from 'view/activity/filterView';
import FilterMobileView from 'view/activity/filterMobileView';
import FilterNativeMobileView from 'view/activity/filterNativeMobileView';
import filterValidator from 'view/activity/filterValidator';
import DisplayModel from 'model/activity/displayModel';
import DisplayView from 'view/activity/displayView';
import LoadMoreView from 'view/activity/loadMoreView';
import LoadMoreModel from 'model/activity/loadMoreModel';
import { isWireless } from 'lib/wurfl';
import pxp from 'lib/pxp';

export default function activitySetup (context = 'activity', serverData = {}) {

	/**
	 * @return FilterModel
	 */
	function setupFilter() {
		let filterView;
		let filterModel = new FilterModel();

		if (isWireless) {
			let ua = navigator.userAgent.toLowerCase();
			let androidMatch = ua.match(/android\s([0-9\.]*)/);
			// load fallback datepicker mobile view for Android 4.4 or less
			if (androidMatch && (parseFloat(androidMatch[1]) < 4.4)) {
				filterView = new FilterMobileView({
					model: filterModel,
					filterValidator
				});
			} else {
				// load native datpicker for iOS and Android 4.4+
				filterView = new FilterNativeMobileView({
					model: filterModel,
					filterValidator
				});
			}
		} else {
			// Filter View for Desktop / Tablet
			filterView = new FilterView({
				model: filterModel,
				filterValidator
			});
		}

		return {
			filterModel,
			filterView
		};
	}

	/**
	 * @return MessageModel
	 */
	function setupMessage(filterModel) {
		// Message
		let messageModel = new MessageModel({
			filterModel: filterModel,
			statementLinksObject: serverData.statementLinks
		});

		let messageView = new MessageView({ model: messageModel });

		return {
			messageModel,
			messageView
		};
	}

	// Simple/Detailed Toggle
	function setupDisplay() {
		let displayModel = new DisplayModel({
			showDetailedView: serverData.showDetailedView
		});

		let displayView = new DisplayView({
			model: displayModel
		});

		return {
			displayView,
			displayModel
		};
	}

	function setupActivityModel() {
		// ActivityModel
		let activityModel = new ActivityModel();
		activityModel.setError(serverData.error);

		return {
			activityModel
		};
	}

	/**
	 * TODO this needs cleanup
	 *	- transactionCollection should not need .data property. See
	 *	  public/js/view/activity/transactionCollectionView.js line 106
	 *	- page-level data should be bound to ActivityModel, not TransactionCollectionView
	 */
	function setupTransactions(transactions, activityModel, filterModel = false, messageModel = false) {
		// Transaction Collection
		let transactionCollection = new TransactionCollection(transactions, {
			activityModel,
			filterModel,
			messageModel
		});

		transactionCollection.data = [transactions];

		let transactionCollectionView = new TransactionCollectionView({
			viewContext: context,
			country: serverData.country,
			collection: transactionCollection,
			showDetailedView: serverData.showDetailedView,
			hasTransactionsPending: serverData.hasTransactionsPending || false,
			hasTransactionsCompleted: serverData.hasTransactionsCompleted || false,
			isMerchantCategoryEnabled: serverData.isMerchantCategoryEnabled || false,
			noOfTransactions: serverData.noOfTransactions || 0,
			statementLinks: serverData.statementLinks || [],
			showLoadMore: serverData.showLoadMore,
			nextPageToken: serverData.nextPageToken,
			currencyCodes: serverData.currencyCodes,
			freeTextSearch: serverData.freeTextSearch
		});

		return {
			transactionCollection,
			transactionCollectionView
		};
	}

	function setupLoadMore(transactionCollection) {
		let loadMoreModel = new LoadMoreModel();
		let loadMoreView = new LoadMoreView({
			model: loadMoreModel,
			collection: transactionCollection
		});

		return {
			loadMoreView,
			loadMoreModel
		};
	}

	function setupActivityPage() {
		const { filterModel } = setupFilter();
		const { messageModel } = setupMessage(filterModel);
		const { activityModel } = setupActivityModel();
		const { transactionCollection } = setupTransactions(serverData.transactions, activityModel, filterModel, messageModel);

		setupDisplay();
		setupLoadMore(transactionCollection);
	}

	function setupSummaryPage() {
		const { activityModel } = setupActivityModel();
		const isNewActivityEnabled = pxp.isTreatment('8ball_pp_activitynodeweb_throttle_treatment'); // pxp.hasTreatment()

		if (!isNewActivityEnabled) {
			setupTransactions(serverData.transactions, activityModel);
		} else {
			// The setup code would be part of the widget js bundle
		}
	}

	/**
	 * Start up Summary page or Activity page objects
	 */

	if (context === 'activity') {
		return setupActivityPage();
	}

	return setupSummaryPage();

}



// WEBPACK FOOTER //
// ./routes/activitySetup.es6